const SET_AUTHENTICATION_FAILURE_DATA = 'SET_AUTHENTICATION_FAILURE_DATA';
const CLEAR_COMMON_STATE = 'CLEAR_COMMON_STATE';

export const accountActionTypes = {
    SET_AUTHENTICATION_FAILURE_DATA,
    CLEAR_COMMON_STATE
};